import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAutenticacao } from '../../contextos/ContextoAutenticacao';
import ComponenteCarregamento from '../comuns/ComponenteCarregamento';

interface Props {
  children: ReactNode;
}

/**
 * RotaProtegidaAdmin
 *
 * Wrapper para proteger rotas que exigem autenticação E permissão de administrador.
 * - Mostra loading enquanto o contexto autenticação estiver carregando
 * - Redireciona para /login se não autenticado
 * - Redireciona para / se autenticado mas não for admin
 * - Renderiza children quando autenticado como admin
 */
export function RotaProtegidaAdmin({ children }: Props) {
  const { estaAutenticado, estaCarregando, usuario } = useAutenticacao();
  const localizacao = useLocation();

  if (estaCarregando) {
    return <ComponenteCarregamento />;
  }

  if (!estaAutenticado) {
    return <Navigate to="/login" state={{ from: localizacao }} replace />;
  }

  // Verifica se o usuário é admin
  if (usuario?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
